import { uniqWith } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { OrganizationMaterialSet } from '@paragon/contract-library';
import { getLoggedInUsersOrganizationMaterialSet, lumbersAreEqual } from '@paragon/material-lists';

import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export function getUniqueLumbersInLumberList(materialSet: OrganizationMaterialSet | null, lumberListGuid: string) {
  const lumberList = materialSet?.lumberLists[lumberListGuid];
  if (lumberList == null) return [];

  return uniqWith(
    lumberList.stockLumbers.map((stockLumber) => stockLumber.lumber),
    lumbersAreEqual,
  );
}

export const getUniqueLumbersInLumberListForActiveComponentDesign = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  getActiveComponentDesign,
  (materialSet, activeComponentDesign) =>
    activeComponentDesign
      ? getUniqueLumbersInLumberList(materialSet, activeComponentDesign.materialSelection.lumberListGuid)
      : [],
);
